export const ROOT_API_URL = process.env.REACT_APP_API_URL;
export const STATIC_ASSEST_URL = process.env.REACT_APP_STATIC_ASSET_URL;
export const DEFAULT_USER_IMAGE_URL = `${STATIC_ASSEST_URL}/media/users/default-user-image.png`;
export const DEFAULT_CONTACT_CARD_IMAGE_URL = `${STATIC_ASSEST_URL}/media/generic_contact_card.jpg`;
export const FACEBOOK_APP_ID = '1204311012996577';
export const LOGROCKET_APP_ID = 'khajup/myhellohello';
export const SENTRY_URL = 'https://ca9a3abcab93478e85b4b8a5a7fde554@sentry.io/1449391';


// WEBPACK FOOTER //
// ./src/app.config.js